import { useMergeTagsStore } from "@/stores/mergeTags";

export default (href: string): boolean => {
  const mergeTagsStore = useMergeTagsStore();
  const syntax = mergeTagsStore.smartMergeTags?.syntax || {
    start: "*|",
    end: "|*",
  };
  const startMergeTagSyntax = syntax.start || "*|";
  const startsWithSpecialChar = /^[^a-zA-Z0-9]/.test(href);
  if (
    href &&
    !href.startsWith("mailto") &&
    !href.startsWith("tel") &&
    !href.startsWith(startMergeTagSyntax) &&
    !startsWithSpecialChar &&
    !href.startsWith("http")
  ) {
    return false;
  }
  return true;
};
